import { useRef } from 'react'
import Modal from '../../../core/components/Modal'
import useCountries from '../../../core/hooks/useCountries'
import useRequestsActions from '../../hooks/useRequestsActions'
import { toastSuccess } from '../../../../config/global'
import { FaSpinner } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'

export default function ModalSponsorRegister({ isOpen, onClose, sponsor_package_id, duration }) {
  const { lng } = useParams()
  const { countries } = useCountries()
  const navigate = useNavigate()
  const { createSponsorRequest, inProgress } = useRequestsActions()
  const fullnameRef = useRef(null)
  const entityRef = useRef(null)
  const emailRef = useRef(null)
  const phoneRef = useRef(null)
  const countryIdRef = useRef(null)
  const { t } = useTranslation()
  async function handleOnSubmit(event) {
    event.preventDefault()

    const payload = {
      sponsor_package_id,
      full_name: fullnameRef.current.value,
      concerned_party: entityRef.current.value,
      country_id: countryIdRef.current.value,
      email: emailRef.current.value,
      phone: phoneRef.current.value,
      duration: duration,
    }

    const message = await createSponsorRequest(payload)

    if (message) {
      toastSuccess(message)
      onClose()
      navigate(`/${lng}/home`)
    }
  }
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      dir={lng === 'ar' ? 'rtl' : 'ltr'} // Dynamique pour tout le modal
      className={`w-full border-2 border-muted-300 bg-white lg:w-1/2`}
    >
      <form
        onSubmit={handleOnSubmit}
        dir={lng === 'ar' ? 'rtl' : 'ltr'} // Dynamique pour le formulaire
      >
        <div className="w-full border-b-2 border-muted-300 bg-gray-100 p-4 px-5 font-bold">{t('registration_form')}</div>

        <div className="flex flex-col gap-4 p-4">
          <div className={`flex gap-4 ${lng === 'ar' ? 'flex-row-reverse' : ''}`}>
            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_FULL_NAME"
              >
                {t('full_name')} <span className="text-danger-700">*</span>
              </label>
              <input
                id="ID_FULL_NAME"
                className="w-full border-2 border-muted-300 px-4 py-2 focus:outline-none"
                type="text"
                ref={fullnameRef}
              />
            </div>

            <div className="flex w-full flex-col gap-1">
              <label
                className="font-bold"
                htmlFor="ID_ENTITY"
              >
                {t('entity')} <span className="text-danger-700">*</span>
              </label>
              <input
                id="ID_ENTITY"
                className="w-full border-2 border-muted-300 px-4 py-2 focus:outline-none"
                type="text"
                ref={entityRef}
              />
            </div>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_COUNTRY_ID"
            >
              {t('country')} <span className="text-red-700">*</span>
            </label>
            <select
              id="ID_COUNTRY_ID"
              ref={countryIdRef}
              className="w-full border-2 border-muted-300 px-4 py-2 focus:outline-none"
            >
              <option value="">{t('select_country')}</option>
              {countries?.map((country) => (
                <option
                  key={country.id}
                  value={country.id}
                >
                  {country[`name_${lng}`]}
                </option>
              ))}
            </select>
          </div>

          <div className="flex w-full flex-col gap-1">
            <label
              className="font-bold"
              htmlFor="ID_EMAIL"
            >
              {t('email')} <span className="text-red-700">*</span>
            </label>
            <input
              className="w-full border-2 border-muted-300 px-4 py-2 focus:outline-none"
              type="email"
              ref={emailRef}
              id="ID_EMAIL"
            />
          </div>

          <div>
            <label
              className="font-bold"
              htmlFor="ID_PHONE"
            >
              {t('mobile')} <span className="text-red-700">*</span>
            </label>
            <input
              className="w-full border-2 border-muted-300 px-4 py-2 focus:outline-none"
              type="tel"
              ref={phoneRef}
              id="ID_PHONE"
            />
          </div>

          <div className="flex flex-col gap-2">
            <button
              disabled={inProgress}
              className="flex w-full items-center justify-center border-2 border-primary-600 bg-primary-600 p-3 font-bold text-white hover:border-secondary-600 hover:bg-secondary-600 disabled:cursor-not-allowed disabled:border-muted-300 disabled:bg-muted-100 disabled:text-dark"
              type="submit"
            >
              {inProgress ? (
                <div className="flex items-center">
                  <FaSpinner
                    size={16}
                    className="ml-4 animate-spin"
                  />
                  <span>{t('registering')}</span>
                </div>
              ) : (
                <span>{t('registration')}</span>
              )}
            </button>
            <div className="w-full text-center">{t('sponsor_contact')}</div>
          </div>
        </div>
      </form>
    </Modal>
  )
}
